// @flow

import { fetchDataAndRedirectUser } from './combined'
import { userIsLoggedInFetchingAllData } from './auth'
import {
  checkHttpStatus,
  getApiHeaders,
  getApiBaseUrl,
  basicGet,
  checkForPolicyChanges
} from '../utils/api'
import { showModal, forceHideModal } from './_modal'
import { push } from 'connected-react-router'

export const SET_USER_POLICIES_ACCEPTED = 'SET_USER_POLICIES_ACCEPTED'
export const SET_POLICIES_TO_ACCEPT = 'SET_POLICIES_TO_ACCEPT'
export const UNSET_POLICIES_TO_ACCEPT = 'UNSET_POLICIES_TO_ACCEPT'
export const REQUEST_POLICIES = 'REQUEST_POLICIES'
export const RECEIVE_POLICIES = 'RECEIVE_POLICIES'
export const USER_IS_CONSIDERING_DECLINING_POLICIES =
  'USER_IS_CONSIDERING_DECLINING_POLICIES'
export const USER_IS_NOT_CONSIDERING_DECLINING_POLICIES =
  'USER_IS_NOT_CONSIDERING_DECLINING_POLICIES'

export function setUserPoliciesAccepted(): Object {
  return {
    type: SET_USER_POLICIES_ACCEPTED
  }
}

export function requestPolicies(): Object {
  return {
    type: REQUEST_POLICIES
  }
}

export function receivePolicies(json: Object): Object {
  return {
    type: RECEIVE_POLICIES,
    policies: json.policies
  }
}

export function userIsConsideringDecliningPolicies(): Object {
  return {
    type: USER_IS_CONSIDERING_DECLINING_POLICIES,
    userIsConsideringDecliningPolicies: true
  }
}

export function userIsNotConsideringDecliningPolicies(): Object {
  return {
    type: USER_IS_NOT_CONSIDERING_DECLINING_POLICIES,
    userIsConsideringDecliningPolicies: false
  }
}

export function setPoliciesToAcceptAction(policies: any): Object {
  return {
    type: SET_POLICIES_TO_ACCEPT,
    policiesToAccept: policies
  }
}

export function unsetPoliciesToAcceptAction(): Object {
  return {
    type: UNSET_POLICIES_TO_ACCEPT
  }
}

export async function userNeedsToAcceptPolicies(
  token: string
): Promise<string> {
  const response = await fetch(`${getApiBaseUrl()}/status`, {
    method: 'GET',
    headers: {
      Authorization: `Token token="${token}"`,
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })

  return checkForPolicyChanges(response)
}

export function setPoliciesToAccept(policies: any): Object {
  return dispatch => {
    dispatch(setPoliciesToAcceptAction(policies))
    dispatch(showModal('ACCEPT_POLICIES', {}))
  }
}

export function acceptPolicies(): Function {
  return async (dispatch, getState) => {
    const state = getState()

    checkHttpStatus(
      await fetch(
        `${getApiBaseUrl()}/policies/${state.policies.policiesToAccept}/accept`,
        {
          method: 'PATCH',
          headers: getApiHeaders(state)
        }
      )
    )

    await dispatch(setUserPoliciesAccepted())

    const ns = getState()
    const isMentor = ns.auth.isMentor
    const isGuardian = ns.auth.user.guardian_user

    let currentOrg = ns.auth.user.organizations.find(function (org) {
      return org.id === ns.auth.user.org_id
    })

    if (isGuardian) {
      await dispatch(unsetPoliciesToAcceptAction())
      await dispatch(forceHideModal())
      await dispatch(push('/guardianlobby'))
    } else {
      await dispatch(unsetPoliciesToAcceptAction())
      await dispatch(forceHideModal())
      await dispatch(userIsLoggedInFetchingAllData())
      await dispatch(fetchDataAndRedirectUser(ns.auth.user, currentOrg, isMentor, isGuardian))
    }
  }
}

export function fetchPolicies(): Function {
  return (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrl()}/policies.json`
    return basicGet(
      state,
      dispatch,
      url,
      requestPolicies,
      receivePolicies,
      null
    )
  }
}

export function shouldFetchPolicies(state: Object): boolean {
  const policies = state.policies
  if (policies.items.length === 0) {
    return true
  }

  if (state.policies.isFetching) {
    return false
  }

  return false
}

export function fetchPoliciesIfNeeded(): Function {
  return (dispatch, getState) => {
    if (shouldFetchPolicies(getState())) {
      return dispatch(fetchPolicies())
    } else {
      // lame af, but without this, this function returns without a promise
      return dispatch(function () {
        return Promise.resolve()
      })
    }
  }
}
